import { render, staticRenderFns } from "./ListPros.vue?vue&type=template&id=32936e24&"
import script from "./ListPros.vue?vue&type=script&lang=js&"
export * from "./ListPros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports